var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAssetTypeAutodesk = function SvgAssetTypeAutodesk(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m2.107 19 12.25-7.798h6.355c.196 0 .37.16.37.38 0 .18-.076.26-.174.32l-6.019 3.69c-.392.241-.527.721-.527 1.08l-.007 2.326H22V5.48c0-.26-.196-.48-.488-.48H14.22L2 12.762v6.236h.107z"
  })));
};
export default SvgAssetTypeAutodesk;